// Device-local activity log behind the hub's "Session History" page.
// Deliberately localStorage-only: it records what happened ON THIS DEVICE
// (tests opened, submitted, sign-ins), complementing the server-side
// "My Results" history. Capped so it can never grow unbounded.
const LOG_KEY = "ulearnSessionLog";
const MAX_EVENTS = 200;

/** @param {string} type - e.g. 'test_opened' | 'test_submitted' | 'signed_in'
 *  @param {Object} [data] - small headline payload (test id, score, ...) */
export const addSessionEvent = (type, data = {}) => {
  try {
    const log = getSessionEvents();
    log.unshift({ type, data, at: new Date().toISOString() });
    localStorage.setItem(LOG_KEY, JSON.stringify(log.slice(0, MAX_EVENTS)));
  } catch {
    /* storage full/blocked — activity log is best-effort by design */
  }
};

/** Newest first. */
export const getSessionEvents = () => {
  try {
    const log = JSON.parse(localStorage.getItem(LOG_KEY) || "[]");
    return Array.isArray(log) ? log : [];
  } catch {
    return [];
  }
};

export const clearSessionEvents = () => {
  try {
    localStorage.removeItem(LOG_KEY);
  } catch {
    /* ignore */
  }
};
